import { jsx as _jsx } from "react/jsx-runtime";
function initials(name) {
    return name
        .split(' ')
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');
}
export function Avatar({ name, size = 'md', src, className = '' }) {
    const dim = size === 'md' ? 'w-12 h-12 text-[15px]' : 'w-9 h-9 text-[13px]';
    if (src) {
        return (_jsx("img", { src: src, alt: name, className: `${dim} rounded-full object-cover shrink-0 ${className}` }));
    }
    return (_jsx("span", { className: `${dim} rounded-full bg-primary-container text-primary font-semibold flex items-center justify-center shrink-0 select-none ${className}`, "aria-label": name, children: initials(name) }));
}
